import { useParams } from "react-router-dom";

export const NEW_CHAT_ID = "new"; 
export const useChatId = () => {
  // 使用解构，以获得 id。
  const { id } = useParams<{ id: string }>();
  const chatId = id || NEW_CHAT_ID; 
  return { chatId };
};